import { AnalyticsService } from "@app/util/analytic/AnalyticsService";

const mileageTrackingAnalytics = new AnalyticsService([
  "Reports",
  "General Reports",
  "Mileage Tracker",
]);

export default mileageTrackingAnalytics;
